import {warehouseSourcesClient, WarehouseSourcesResponse} from 'common/report/queries/app-api/warehouse-sources';
import {ApiSingleValueResource} from 'common/util/model-resource/api-resource';

import {getProjectId} from '../util';

export class WarehouseSourcesResource extends ApiSingleValueResource<WarehouseSourcesResponse> {
  apiClient = warehouseSourcesClient;

  constructor({projectId = null, urlManager = null} = {}) {
    super();
    this.id = projectId ?? getProjectId(urlManager);
  }
}
